import { createBrowserHistory } from 'history';

/**
 * Single browser history instance shared across the app.
 *
 * It is passed to the top-level <Router> (see index.tsx) so that non-React
 * modules — namely the auth layer (api/auth.ts) — can trigger navigation
 * (e.g. redirect to login on 401) without needing a component/hook context.
 */
export const history = createBrowserHistory();
